import { FormatMobile } from "@helpers/masker.helper";
import { UsageEvent } from "@services/sdk/types";
import moment, { type Moment } from "moment";

interface IUsageRecordConstructorParams {
	unitType: string;
	usageTstamp: string | Date;
	usageDuration: number;
	isRoaming: boolean;
	usageValue: number;
	eventType: UsageEvent;
	destinationNumber: string;
}

interface UsageRecordContent {
	title: (record: UsageRecord) => string;
	value?: Function;
	info?: Function;
}

const UsageEventTypeMap = new Map<UsageEvent, UsageRecordContent>([
	[
		UsageEvent.DATA,
		{
			title: (record: UsageRecord): string =>
				record.isRoaming ? "Roaming Data" : "Data",
			value: (record: UsageRecord): string => {
				return `${record.responseData.usageDuration}${record.responseData.unitType}`;
			},
		},
	],
	[
		UsageEvent.SMS,
		{
			title: (record: UsageRecord): string =>
				record.isRoaming ? "Roaming SMS" : "SMS",
			value: (record: UsageRecord): string => {
				return FormatMobile(record.responseData.destinationNumber);
			},
		},
	],
	[
		UsageEvent.CALLS,
		{
			title: (record: UsageRecord): string =>
				record.isRoaming ? "International Call" : "Call",
			value: (record: UsageRecord): string => {
				return FormatMobile(record.responseData.destinationNumber);
			},
			info: (record: UsageRecord): string => {
				const duration = moment.duration(
					record.responseData.usageDuration * 1000,
				);

				return moment.utc(duration.as("milliseconds")).format("HH:mm:ss");
			},
		},
	],
]);

class UsageRecord {
	public static ConstructList(
		arrParams: Array<IUsageRecordConstructorParams>,
	): Array<UsageRecord> {
		return arrParams.map(UsageRecord.Construct);
	}

	public static Construct(params: IUsageRecordConstructorParams): UsageRecord {
		return new UsageRecord(params);
	}

	responseData: IUsageRecordConstructorParams;

	constructor(params: IUsageRecordConstructorParams) {
		this.responseData = params;
	}

	private get typeMap(): UsageRecordContent {
		const res = UsageEventTypeMap.get(this.responseData.eventType);

		if (!res) {
			return {
				title: () => "none",
			};
		}

		return res;
	}

	get title(): string {
		return this.typeMap.title(this);
	}

	get date(): Moment {
		return moment(this.responseData.usageTstamp);
	}

	get value(): string | null {
		return this.typeMap.value ? this.typeMap.value(this) : null;
	}

	get info(): string | null {
		return this.typeMap.info ? this.typeMap.info(this) : null;
	}

	get isRoaming(): boolean {
		return this.responseData.isRoaming;
	}
}

export default UsageRecord;
